/**
 * FÁJLNÉV KÖZÉPEN CSONKOLVA — a névnek a VÉGE is számít (#26/#36).
 *
 * ═══ MIÉRT NEM ELÉG A `text-overflow: ellipsis` ═══
 *
 * A CSS a VÉGÉT vágja le. A feltöltött fájlneveknél viszont pont a vége hordoz
 * jelentést: a kiterjesztés, és jellemzően a dátum vagy a sorszám is oda kerül
 * (`Beolvasott_20260908 (8).pdf`). Végponti csonkolással két külön papír
 * ugyanúgy néz ki — „Beolvasott_2026…" —, és az ügyfél nem tudja megmondani,
 * melyiket nyitja meg.
 *
 * Viktor döntése artboardon (2026-09-15, „A" változat): a név ELEJE és VÉGE
 * marad, a közepe vész el. Az ár kimondva: ha a megkülönböztető jel a név
 * KÖZEPÉN van, az itt sem látszik — de az ritkább, mint a végén álló sorszám.
 *
 * ═══ MIÉRT ITT, ÉS NEM CSS-BEN ═══
 *
 * A középső csonkolást a CSS önmagában nem tudja. A megjelenítés két dobozból
 * áll: az ELSŐ rugalmas és ellipszissel vág, a MÁSODIK `flex: none`, tehát
 * sosem zsugorodik. Ehhez a nevet el kell hasítani — ez a függvény teszi, és
 * ezért tesztelhető a felület nélkül.
 */

/**
 * A VÉGÉBŐL ENNYI MARAD MINDIG.
 *
 * Tizenkettő: elfér benne a leghosszabb szokásos kiterjesztés (`.jpeg`) és
 * előtte még hét karakter — annyi, amennyi egy sorszámot vagy egy dátum
 * végét hordozza (`908 (8).pdf`). Kevesebbnél a kiterjesztés maga töltené ki;
 * többnél az ELEJÉBŐL venne el, ami a partner nevét viszi.
 */
const TAIL = 12;

/**
 * ENNÉL RÖVIDEBB NEVET NEM HASÍTUNK.
 *
 * A hasítás ára egy második doboz, ami sosem zsugorodik: ha a név amúgy is
 * elférne, ez a doboz fölöslegesen foglalna helyet a sorban. A küszöb a farok
 * kétszerese — alatta a név vagy elfér, vagy a végponti ellipszis is elég.
 */
const MIN_SPLIT = TAIL * 2;

export interface SplitName {
  /** A rugalmas rész — ez kap ellipszist, ha nem fér ki. */
  head: string;
  /** A mindig látható vég. Üres, ha a nevet nem hasítottuk. */
  tail: string;
}

export function splitFilename(name: string): SplitName {
  if (name.length <= MIN_SPLIT) {
    return { head: name, tail: '' };
  }
  return { head: name.slice(0, name.length - TAIL), tail: name.slice(-TAIL) };
}
